import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { OPD_CONST } from '../../properties/opd-static-properties';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';

@Component({
  selector: 'app-kin-details-dialog',
  templateUrl: './kin-details-dialog.component.html',
  styleUrls: ['./kin-details-dialog.component.scss']
})

export class KinDetailsDialogComponent implements OnInit, OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  private subscriptionList = new Subscription();
  protected _onDestroy = new Subject<void>();
  displayedColumnsNextOfKinDetails: string[] = OPD_CONST.displayedColumnsNextOfKinDetails;
  dataSourceNextOfKin: MatTableDataSource<any> = new MatTableDataSource<any>();
  ElementNextofKin: any[]=[];

  constructor(
    public dialogRef: MatDialogRef<KinDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private appBaseService: AppBaseService,
  ) { }

  ngOnInit(): void {
    this.getNextOfKinDetails(this.data);

  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
  }

  /**
   * closing dialog
   */
  onClick() {
    this.dialogRef.close();
  }

  /**
   * 
   * @param rowData 
   */
  getNextOfKinDetails(rowData) {
    this.data = rowData;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.GET_KIN_DETAILS_LIST_BY_ENCOUNTER_ID + this.data.id)
      .subscribe((response) => {
        this.ElementNextofKin = [];
        response.forEach((element) => {
          if(element.active==true){
         let obj={
            name:element.name?element.name:null,
            relation:element.relation?element.relation.desc:null,
            identificationType:element.identifierType?element.identifierType.desc:null,
            identificationNo:element.identificationNo?element.identificationNo:null,
            mobileNo: element.mobileNo?element.mobileNo:null,
            isGurantor: element.isGurantor == true ? true : false,
            id: element.id?element.id:null,
          }
          this.ElementNextofKin.push(obj);
        }
        });
      
          this.dataSourceNextOfKin = new MatTableDataSource<any>(
            this.ElementNextofKin
          );
      
    });
  }


  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }
}

